<template>
  <div class="el-col-24">
    <h5 class="warp-title">账号管理</h5>
    <div class="search mb15">
      <span>查找用户</span>
      <el-input class="input-css" size="small" v-model.trim="mName" placeholder="输入真实姓名" clearable></el-input>
      <span>状态</span>
      <el-select placeholder="请选择状态" v-model="status" size="small">
        <el-option label="全部" :value="-1"></el-option>
        <el-option label="正常" :value="0"></el-option>
        <el-option label="禁用" :value="1"></el-option>
      </el-select>
      <el-button v-if="querybtn.accountmanage_query === 1" class="btn-c" size="small" @click="search" type="primary">查找</el-button>
      <router-link v-if="querybtn.accountmanage_add === 1" class="blue" :to="{name: 'AccountAdd'}" tag="span">
        <el-button class="btn-c" size="small" type="primary">新增</el-button>
      </router-link>
    </div>
    <el-table
      :data="tableData"
      border
      align="center"
      style="width: 100%">
      <el-table-column
        label="账号"
        prop="nickName"
        align="center">
      </el-table-column>
      <el-table-column
        label="角色"
        prop="roleName"
        align="center">
      </el-table-column>
      <el-table-column
        label="真实姓名"
        prop="realName"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createTime"
        align="center">
      </el-table-column>
      <el-table-column
        label="分组"
        prop="customerGroupName"
        align="center">
      </el-table-column>
      <el-table-column
        label="状态"
        align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">正常</span>
          <span v-else-if="scope.row.status === 1">禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="300">
        <template slot-scope="scope">
          <div class="operating">
            <router-link v-if="querybtn.accountmanage_edit === 1" class="green cursor" :to="{name: 'AccountEdit', query:{userId: scope.row.userId, state: 1}}">编辑</router-link>
            <span v-if="querybtn.accountmanage_delete === 1">
              <span v-if="scope.row.status === 0" class="red" @click="resetOperating(scope.row.userId, scope.row.status, '禁用')">禁用</span>
              <span v-else class="green" @click="resetOperating(scope.row.userId, scope.row.status, '恢复')">恢复</span>
            </span>
            <span class="red" @click="toResetPassword(scope.row)">重置密码</span>
            <router-link v-if="querybtn.accountmanage_viwe_permission === 1" class="green cursor" :to="{name: 'EditSeeRole', params:{userId: scope.row.userId}}">编辑查看权限</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt20"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align='right'
      background>
    </el-pagination>
    <!-- 重置密码 -->
    <el-dialog
      title="重置密码"
      :show-close="false"
      :visible.sync="showReset"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <el-form :model="resetForm" size="small" label-position="top" ref="resetForm"  class="demo-shieldForm">
        <el-form-item label="备注">
          <el-input maxlength="50" type="textarea" v-model="resetForm.remark" @change="resetForm.remark=resetForm.remark.trim()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showReset = false">取 消</el-button>
        <el-button class="ml15" size="small" type="primary" @click="submitReset" :loading="isResetLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryAccountPage, deleteUserAccount, resetUserPwd } from '../../../api/power/account'
import { queryButtonPermission } from '../../../api/public/auth'
export default {
  name: 'Account',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  data () {
    return {
      isResetLoading: false,
      resetForm: {
        remark: '',
        userId: ''
      },
      showReset: false,
      tableData: [],
      total: 10,
      mName: '',
      status: 0,
      currentPage: 1,
      pageSize: 10,
      querybtn: {}
    }
  },
  methods: {
    // 提交密码重置
    submitReset () {
      this.isResetLoading = true
      resetUserPwd(this.resetForm).then(res => {
        this.showReset = false
        if (res.data.resultCode === 0) {
          let password = res.data.resultData.resetPwd
          this.$alert(`账号密码为：${password}，请注意保存。`, '密码重置成功！', {
            confirmButtonText: '复制密码并关闭',
            center: true,
            callback: action => {
              this.$copy(password)
              this.$message.success('复制成功')
            }
          })
        } else {
          this.$alert(`${res.data.resultMessage}`, '密码重置失败！', {
            confirmButtonText: '我知道了',
            center: true
          })
        }
      }).finally(() => {
        this.isResetLoading = false
      })
    },
    // 打开密码重置
    toResetPassword (item) {
      this.resetForm.userId = item.userId
      this.showReset = true
    },
    currentChange (val) {
      this.currentPage = val
      this.initData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.initData()
    },
    initData () {
      let data = {
        currPage: this.currentPage,
        pageSize: this.pageSize,
        realName: this.mName,
        status: this.status
      }
      queryAccountPage(data).then(info => {
        let data = info.data
        if (data.resultCode === 0) {
          this.total = data.totalCount
          this.tableData = data.resultData
          let pageNum = Math.ceil(data.totalCount / this.pageSize)
          if (pageNum !== 0 && this.currentPage > pageNum) {
            this.currentPage = pageNum
            this.initData()
          }
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    },
    resetOperating (userId, key, val) {
      this.$confirm(`确认${val}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          userId: userId,
          status: key
        }
        deleteUserAccount(param).then(res => {
          if (res.data.resultCode === 0) {
            this.$message.success(res.data.resultMessage)
            this.initData()
          } else {
            this.$message.error(res.data.resultMessage)
          }
        })
      })
    },
    search () {
      this.currentPage = 1
      this.initData()
    }
  },
  mounted () {
    this.initData()
  }
}
</script>
<style lang="less" scoped>
a{
  color: #16BB5A;
  text-decoration: underline;
}
.el-button+.el-button{
  margin-left: 0;
}
.el-button--small{
  padding: 9px 10px;
}
.mb15{
  margin-bottom: 15px;
}
.el-col-24{
  font-size: 14px;
}
.input-css{
  width: 250px;
  margin: 0 10px 0 10px;
}
.btn-c{
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Power/Account/Index.vue